import { render, staticRenderFns } from "./EditEmployee.vue?vue&type=template&id=65936b71&scoped=true&"
import script from "./EditEmployee.vue?vue&type=script&lang=ts&"
export * from "./EditEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65936b71",
  null
  
)

export default component.exports